import request from '@/router/axios';

// 新增应急物资
export const add = (data) => {
  return request({
    url: '/api/produce/emergency-material/insert',
    method: 'post',
    data,
  });
};

// 更新应急物资
export const update = (data) => {
  return request({
    url: '/api/produce/emergency-material/update',
    method: 'post',
    data,
  });
};

// 获取应急物资详情
export const getDetail = (id) => {
  return request({
    url: '/api/produce/emergency-material/select/id',
    method: 'get',
    params: { id },
  });
};

// 获取应急物资列表（分页）
export const getList = (data) => {
  return request({
    url: '/api/produce/emergency-material/select/page',
    method: 'post',
    data,
  });
};

// 获取应急物资列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: '/api/produce/emergency-material/select/distinct/page',
    method: 'post',
    data,
  });
};

// 删除应急物资（单个）
export const remove = (id) => {
  return request({
    url: '/api/produce/emergency-material/delete/id',
    method: 'get',
    params: { id },
  });
};

// 批量删除应急物资
export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/emergency-material/delete/ids',
    method: 'get',
    params: { ids },
  });
};

export const downloadImportTemplate = () => {
  return request({
    url: '/api/produce/emergency-material/import-template',
    method: 'get',
    responseType: 'blob',
  });
};

export const exportExcel = (data) => {
  return request({
    url: '/api/produce/emergency-material/export/excel',
    method: 'post',
    data,
    responseType: 'blob',
  });
};

export const getContractExtpage = (params) => {
  return request({
    url: '/api/produce/transport-contract-ext/select/contractExtpage',
    method: 'get',
    params
  })
}

